import { render } from "./ItemButton.vue?vue&type=template&id=6c0754ff&scoped=true"
import script from "./ItemButton.vue?vue&type=script&lang=js"
export * from "./ItemButton.vue?vue&type=script&lang=js"

import "./ItemButton.vue?vue&type=style&index=0&id=6c0754ff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c0754ff"

export default script